import React, { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import PrizeInstitution from '@components/profile/profileOverlay/overlays/prize/prizeWrite/prizeForm/PrizeInstitution';
import PrizeName from '@components/profile/profileOverlay/overlays/prize/prizeWrite/prizeForm/PrizeName';
import PrizeDate from '@components/profile/profileOverlay/overlays/prize/prizeWrite/prizeForm/PrizeDate';
import PrizeDescription from '@components/profile/profileOverlay/overlays/prize/prizeWrite/prizeForm/PrizeDescription';

import styles from '../../prize.module.scss';
import { PrizeVO } from '@domain/vo/profile/ProfilePrizeVO';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface IPrizeItemProps {
  index: number;
  prefixName: string;
  defaultValues: Record<string, any>;
  onDeleteItem: () => void;
}

const PrizeItem = ({ index, prefixName, defaultValues, onDeleteItem }: IPrizeItemProps) => {
  const { watch } = useFormContext();
  const isDisabledDeleteBtn = index === 0 && Object.values(watch(prefixName) ?? {}).filter((v) => !!v).length === 0;

  return (
    <div className={cx('awardInner')}>
      <button className={cx('btnDelete')} type="button" onClick={onDeleteItem} disabled={isDisabledDeleteBtn}>
        <Icon name="deleteLight" width={20} height={20} />
        삭제
      </button>

      {/* 수여 기관 */}
      <PrizeInstitution prefixName={prefixName} institutionDefaultValue={defaultValues.institution} />
      <PrizeName prefixName={prefixName} nameDefaultValue={defaultValues.name} />
      <PrizeDate prefixName={prefixName} dateDefaultValue={defaultValues.date} />
      <PrizeDescription prefixName={prefixName} descDefaultValue={defaultValues.description} />
    </div>
  );
};

const PrizeForm = () => {
  const { control } = useFormContext();

  const fieldName = 'prizes';
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const onAppendPrize = () => {
    append(
      new PrizeVO({
        institution: '',
        name: '',
        date: '',
        description: '',
      }),
    );
  };

  const prizesEls = fields.map(({ id, ...field }, idx) => {
    const prefixName = `${fieldName}[${idx}]`;
    const onDeleteItem = () => {
      remove(idx);
    };

    return <PrizeItem key={id} index={idx} prefixName={prefixName} defaultValues={field} onDeleteItem={onDeleteItem} />;
  });

  useEffect(() => {
    if (fields.length === 0) {
      onAppendPrize();
    }
  }, [fields.length]);

  return (
    <div className={cx('awardArea')}>
      <em className={cx('sectionTitle')}>수상 내역</em>
      {prizesEls}

      <a className={cx('btnAdd')} role="button" onClick={onAppendPrize}>
        <Icon name="addLight" width={24} height={24} />
        추가
      </a>
    </div>
  );
};

export default PrizeForm;
